export default __webpack_public_path__ + "static/media/i2.9e798dc9.jpg";